<template>
  <footer class="p-6">
    <slot></slot>
  </footer>
</template>
